import { render } from "./IconElectraWheelSize.vue?vue&type=template&id=a5cac760"
import script from "./IconElectraWheelSize.vue?vue&type=script&lang=js"
export * from "./IconElectraWheelSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__